import axios from 'axios';
import { API } from '@/lib/api';

// Owner Override uses a SEPARATE, short-lived admin token kept in sessionStorage
// (cleared when the tab closes) so a shared shop device is never permanently
// bound to the Owner. It never touches the normal employee token (`sc_token`).
const KEY = 'sc_ovr_token';

export const getOvrToken = () => sessionStorage.getItem(KEY);
export const setOvrToken = (t) => sessionStorage.setItem(KEY, t);
export const clearOvrToken = () => sessionStorage.removeItem(KEY);

const ovrApi = axios.create({ baseURL: API, timeout: 15000 });
ovrApi.interceptors.request.use((config) => {
  const t = getOvrToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default ovrApi;
